module.exports = __webpack_public_path__ + "static/img/guitar-match.a1151a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match.png
// module id = Y0Ms
// module chunks = 12